import { Button } from '@mui/material';
import { BaseButtonConfig } from 'core/components/button/BaseButtonConfig';
import React from 'react';

function BaseButton({
	id,
	variant = BaseButtonConfig.defaultVariantType,
	href = '',
	disabled = false,
	onClick = () => {},
	styles = {},
	children = null,
	...props
}) {
	return (
		<Button
			id={id}
			variant={variant}
			href={href}
			disabled={disabled}
			onClick={onClick}
			sx={styles}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		>
			{children}
		</Button>
	);
}

export default BaseButton;
